

export enum EApplicationInsightsEvents {
    SessionLoading = "session.loading",
    WhoAmI = "session.whoami"
}
